import { Component, OnDestroy, OnInit } from '@angular/core';
import { WebsocketService } from '@shared/services/websocket/websocket.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslocoService } from '@jsverse/transloco';
import { CookiesService } from '@core/services/cookies/cookies.service';
import {
  ChatsState,
  WebSocketChatsEventResponse,
} from './@features/chat/models/chat.model';
import { ChatService } from './@features/chat/services/chat.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SeoService } from '@core/services/seo/seo.service';
import { RecaptchaLoaderService } from '@core/services/recaptcha/recaptcha-loader.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  public svgSprite$!: Observable<string>;

  constructor(
    private webSocketService: WebsocketService,
    private httpClient: HttpClient,
    public sanitizer: DomSanitizer,
    private transloco: TranslocoService,
    private cookieService: CookiesService,
    private chatService: ChatService,
    private router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly seoService: SeoService,
    private recaptchaLoader: RecaptchaLoaderService
  ) {
    // this.webSocketService.connect();
  }

  public ngOnInit(): void {
    this.loadSvgSprite();
    this.loadRecaptchaScript();
    this.detectLanguage();

    //ToDO: сокет в тупую не хочет прослушиваться если поместить этот код внутрь компонента чатов или в другое место
    // кроме app component
    this.webSocketService.on(
      'chats',
      (response: WebSocketChatsEventResponse) => {
        this.chatService.currentChatsState$.next(response.data as ChatsState);
      },
      'chat'
    );
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((event) => {
        // get the route, right from the root child
        // this allows a title to be set at any level
        // but for this to work, the routing module should be set with paramsInheritanceStrategy=always
        let route = this.activatedRoute.snapshot;
        while (route.firstChild) {
          route = route.firstChild;
        }
        this.seoService.setTitle(
          route.data.title[this.transloco.getActiveLang()]
        );
      });
  }

  private loadSvgSprite(): void {
    const headers = new HttpHeaders();
    headers.set('Accept', 'image/svg+xml');
    this.svgSprite$ = this.httpClient.get(`assets/images/sprite.svg`, {
      headers,
      responseType: 'text',
    });
  }

  private detectLanguage(): void {
    const lang = this.cookieService.getCookie('language');
    if (lang) {
      this.transloco.setActiveLang(lang.toLowerCase());
    }
  }

  private loadRecaptchaScript(): void {
    this.recaptchaLoader.load(environment.recaptchaSiteKey);
  }

  public ngOnDestroy() {
    this.webSocketService.disconnect();
  }
}
